import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zef-status-flag',
  templateUrl: './status-flag.component.html',
  styleUrls: ['./status-flag.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatusFlagComponent {
  @Input()
  flag?: string;
}
